import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEstadoSanitario = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'estado_sanitario',
        name: 'Estado Sanitario',
        component: ViewEstadoSanitario,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
